import React, { Fragment, Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import { Global, inlineStyles } from '../../utils/global';
import { EnhancedTableToolbar, EnhancedTableHead } from '../../utils/common_page_with_table';
import { Box, Grid, Table, TableBody, TableRow, TableCell, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, MenuItem } from '@material-ui/core';
import { Column, Row } from 'simple-flexbox';

import 'date-fns';
import '../../styles.css';
import { Link } from 'react-router-dom';
import { numberFormat } from '../../utils/common_utils';
import { CSVLink } from "react-csv";

const url = 'gl/generaljournalList.php';

export default class GenJournalList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            branchId: props.parentComponent.state.branchId,
            addNew: false,
            csvData: [],
            deleteDialogOpen: false,
            notification: '',
            isLoading: true,
            isDataLoading: false,
            selectedID: 0,
            objName: '',
            schema: [],
            order: 'desc',
            orderBy: 'date_transaction',
            page: 0,
            pageTotal: 0,
            rows: [],
            rowsPerPage: 100,
            searchFor: '',
            selected: [],
            selectedDate: '',
            selectedDate2: '',
            url: props.parentComponent.state.API_HOST + url,
        };
    }
    openSnackBar = this.props.Journal.openSnackBar;
    changeDate = (e) => {
        var v = e.target.value;
        this.setState({ selectedDate: v });
    }
    changeDate2 = (e) => {
        var v = e.target.value;
        this.setState({ selectedDate2: v });
    }
    setSearch = () => {
        if (this.state.selectedDate) {
            Global.getDataRows(this, this.state.url, 'rows', '', [{ name: 'selectedDate', value: this.state.selectedDate }, { name: 'selectedDate2', value: this.state.selectedDate2 }]);
        }
    }
    handleTextfieldChange = (name) => event => {
        Global.setStateValue(this, name, event.target.value);
        return;
    };
    handleRequestSort = (event, property) => {
        var isDesc = this.state.order === 'desc';
        var order = isDesc || this.state.orderBy !== property ? 'asc' : 'desc';
        var values = {
            order: order,
            orderBy: property,
        };
        this.setComponentState('order', order);
        this.setComponentState('orderBy', property);
        Global.loadList(this, values);
    }
    setComponentState = (sState, vState) => {
        this.setState({ [sState]: vState });
    }
    addNew = (v) => {
        this.setState({ addNew: v });
    }
    editRow = (row) => {
        this.setState({ id: row.id });
        Global.setStateValue(this, 'acode', row.acode);
        Global.setStateValue(this, 'accountname', row.accountname);
        Global.setStateValue(this, 'group_', row.group_);
        Global.setStateValue(this, 'with_sub', row.with_sub);
        this.addNew(true);
    }
    confirmDeleteRow(row) {
        this.setState({ id: row.transCatID });
        this.setState({ objName: row.transCatName });
        this.setDeleteDialogOpen(true);
    }
    confirmDeletion = (id) => {
        Global.deleteRow(this, id);
    }
    setDeleteDialogOpen = (v) => {
        this.setState({ deleteDialogOpen: v });
        if (!v) {
            Global.loadList(this, { isDataLoading: false });
        }
    }
    actionButtons = () => {
        return (
            <Column flexGrow={1}>
                <Row vertical='center' horizontal='right'>                    
                    <Column flexGrow={1} horizontal='center'>
                        From:
                    </Column>
                    <Column flexGrow={1} horizontal='center'>
                        <TextField
                            error={false}
                            variant="outlined"
                            margin="dense"
                            type="date"
                            size="small"
                            required={true}
                            onChange={this.changeDate}
                            disabled={this.state.isDataLoading}
                        />
                    </Column>
                    <Column flexGrow={1} horizontal='center' style={{ paddingLeft: 3 }}>
                        To:
                    </Column>
                    <Column flexGrow={1} horizontal='center'>
                        <TextField
                            error={false}
                            variant="outlined"
                            margin="dense"
                            type="date"
                            size="small"
                            required={true}
                            onChange={this.changeDate2}
                            width={100}
                            disabled={this.state.isDataLoading}
                        />
                    </Column>
                    <Column flexGrow={1} horizontal='center'>
                        <Button onClick={this.setSearch} style={{ marginLeft: 5 }} color="primary" variant='contained' size="small">
                            Generate
                            </Button>
                    </Column>
                    <Column flexGrow={1} horizontal='center'>
                        <div style={{ padding: "5px", whiteSpace: "nowrap" }}>
                            <CSVLink data={this.state.csvData} filename={'GenJournal'}>   
                                <Button variant='contained' size="small" style={inlineStyles.buttonGreen}>
                                Export to Excel
                                </Button>
                            </CSVLink>
                        </div>
                    </Column>

                </Row>
            </Column>
        )
    }
    handleSelectAllClick = (event) => {
        if (event.target.checked) {
            var newSelecteds = this.state.rows.map(n => n.name);
            this.setComponentState('selected', newSelecteds);
            return;
        }
        this.setComponentState('selected', []);
    }

    handleChangePage = (event, newPage) => {
        this.setComponentState('page', newPage);
        Global.loadList(this, { page: newPage });
    }

    handleChangeRowsPerPage = (event) => {
        this.setComponentState('rowsPerPage', event.target.value);
        Global.loadList(this, { rowsPerPage: event.target.value });
    }
    componentDidUpdate() {
        if (this.state.branchId !== this.props.parentComponent.state.branchId) {
            this.setState({ branchId: this.props.parentComponent.state.branchId });
            Global.loadList(this, {});
        }
    }
    componentDidMount() {
        if (this.state.isLoading && !this.state.isDataLoading) {
            Global.getSchema(this, false); /* if second parameter is true, the record to edit will be loaded (getOneRow()); else list will be loaded */
        }
    }
    render() {
        const reportTitle = 'General Journal';

        if (!this.state.branchId || this.state.branchId < 1) {
            var notification = 'Please select a branch first';
        } else {
            var notification = this.state.notification;
        }
        var headRows = [];
        var values = this.state.schema;
        var rows = this.state.rows;
        values.forEach((row) => {
            headRows.push({ id: row.name, label: row.label, numeric: row.numeric, showInList: row.showInList });
        });
        return (
            <Fragment>
                <Paper style={inlineStyles.paper}>
                    {
                        notification &&
                        <div style={{ 'padding': 10, 'color': 'red', 'textAlign': 'center' }}>
                            {notification}
                        </div>
                    }
                    {
                        this.state.isDataLoading &&
                        <Fragment>
                            <div style={{ 'padding': 50, 'textAlign': 'center' }}>
                                <CircularProgress />
                            </div>
                        </Fragment>
                    }

                    {!this.state.isDataLoading &&
                        <Fragment>
                            <EnhancedTableToolbar
                                numSelected={0}
                                toolbarTitle=''
                                actionButtons={this.actionButtons}
                                t={this}
                                Global={Global}
                            />
                            {this.state.addNew &&
                                <Fragment>
                                    <form autoComplete="off" style={inlineStyles.editform}>
                                        <Grid container spacing={2}>
                                            {values.filter((row) => row.type !== 'hidden').map((row, index) => {
                                                var menuItems = row.type === 'select' ? row.items : '';
                                                return (
                                                    row.type === 'select' ?
                                                        <Grid item xs={12} md={row.gridSize ? row.gridSize : 4} key={index}>
                                                            <TextField
                                                                select
                                                                variant="outlined"
                                                                margin="dense"
                                                                autoFocus={row.name === 'acode' ? true : false}
                                                                name={row.name}
                                                                label={row.error ? row.error : row.label}
                                                                value={row.value ? row.value : ''}
                                                                onChange={this.handleTextfieldChange(row.name)}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                disabled={this.state.isDataLoading}
                                                            >
                                                                <MenuItem value={0}>Choose {row.label}</MenuItem>
                                                                {
                                                                    menuItems.length > 0 && menuItems.map((itemrow, itemindex) => {
                                                                        return (
                                                                            <MenuItem key={itemindex} value={itemrow.key}>{itemrow.value}</MenuItem>
                                                                        )
                                                                    })
                                                                }

                                                            </TextField>
                                                        </Grid>
                                                        :
                                                        <Grid item xs={12} md={row.gridSize ? row.gridSize : 4} key={index}>
                                                            <TextField
                                                                error={row.error ? true : false}
                                                                autoFocus={row.name === 'acode' ? true : false}
                                                                variant="outlined"
                                                                margin="dense"
                                                                name={row.name}
                                                                required={row.required}
                                                                label={row.error ? row.error : row.label}
                                                                value={row.value}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                onChange={this.handleTextfieldChange(row.name)}
                                                                disabled={this.state.isDataLoading}
                                                            />
                                                        </Grid>
                                                )
                                            })
                                            }
                                            <Grid item xs={2} style={{ paddingTop: 15 }}>
                                                <Button onClick={Global.handleSaveForm(this)} style={inlineStyles.button} color="primary" variant='contained' size="small">
                                                    <Icon className="fas fa-save" style={inlineStyles.smallIcon}></Icon>Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </Fragment>
                            }
                            <div style={inlineStyles.tableWrapper}>
                                <Table
                                    aria-labelledby="tableTitle"
                                    size='small'
                                >

                                    <EnhancedTableHead
                                        numSelected={this.state.selected ? this.state.selected.length : 0}
                                        order={this.state.order}
                                        orderBy={this.state.orderBy}
                                        onSelectAllClick={this.handleSelectAllClick}
                                        onRequestSort={this.handleRequestSort}
                                        headRows={headRows}
                                        noHashColumn={true}
                                    />
                                    <TableBody>
                                        {this.state.rows && this.state.rows.length > 0 && this.state.rows.map((row, index) => {
                                            const labelId = `table-row-${index}`;
                                            return (
                                                <TableRow
                                                    hover
                                                    key={index} style={(row.summary === 1 ? { backgroundColor: '#f1f1f1', fontWeight: 'bold' } : {})}
                                                >
                                                    {values.filter(col => col.showInList).map((col, colindex) => {
                                                        var rowVal = row[col.name];
                                                        if (col.type === 'select') {
                                                            var menuItem = col.items.find(colItems => colItems.key == rowVal);
                                                            if (typeof menuItem === 'object' && menuItem.hasOwnProperty('value')) {
                                                                rowVal = menuItem.value;
                                                            } else {
                                                                rowVal = '';
                                                            }
                                                        }

                                                        var colval = col.name === 'acode'
                                                            ? (<Link to="#" onClick={() => this.editRow(row)} aria-label="Edit">{rowVal}</Link>)
                                                            : rowVal;
                                                        return (
                                                            <TableCell key={colindex} align={col.numeric ? 'right' : (col.align ? col.align : 'left')}>
                                                                {col.numeric ? numberFormat(colval, 2) : colval}
                                                            </TableCell>
                                                        );
                                                    })
                                                    }

                                                </TableRow>
                                            );
                                        })
                                        }
                                        {this.state.rows && !this.state.rows.length &&
                                            <TableRow><TableCell align="center" colSpan={8}>{"No result"}</TableCell></TableRow>
                                        }
                                    </TableBody>

                                </Table>
                            </div>

                        </Fragment>
                    }

                </Paper>
                <Dialog
                    open={this.state.deleteDialogOpen}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Confirm"}</DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText id="alert-dialog-description"></DialogContentText>
                        <div style={{ padding: 15 }}>
                            Do you want to continue deleting "{this.state.objName}"?
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setDeleteDialogOpen(false)} variant='contained' color="secondary" size="small" style={inlineStyles.button}>
                            No
                    </Button>
                        <Button onClick={() => this.confirmDeletion(this.state.id)} variant='contained' color="primary" size="small" style={inlineStyles.button} autoFocus>
                            Yes
                    </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}